import * as Yup from "yup";

import { phoneNumbersValidation } from "Shared/utils";

export const verifyHCPPhoneNumbersValidation = Yup.object().shape({
  phoneNumbers: phoneNumbersValidation
});
